import { useCallback } from "react";
import { isSourceValue, isCoOccupantInfo } from "./utils";

export const useContractFieldUtils = () => {
  const getEditableFieldValue = useCallback((data: any): string => {
    if (isSourceValue(data)) {
      const value = data.value;
      return value === null || value === undefined ? "" : String(value);
    }
    if (data === null || data === undefined) {
      return "";
    }
    return String(data);
  }, []);

  const getFieldValue = useCallback((data: any): string => {
    if (isCoOccupantInfo(data)) {
      if (!data.value || data.value.length === 0) return "N/A";
      return data.value
        .map((p) => `${p.name || "N/A"} (${p.gender || "N/A"})`)
        .join(", ");
    }
    if (isSourceValue(data)) {
      const value = data.value;
      if (value === null || value === undefined || value === "") {
        return "N/A";
      }
      return String(value);
    }
    if (data === null || data === undefined || data === "") {
      return "N/A";
    }
    return String(data);
  }, []);

  return {
    getEditableFieldValue,
    getFieldValue,
  };
};